import Button from "../Button/Button";
import {useTranslation} from "react-i18next";
import {useRef, useState, useLayoutEffect, useCallback} from "react";
import styles from './TestimonialInput.module.scss';
import testAvatar from "../../../static/imgs/testAvatar.png";

interface IProps {
  placeholder: string
  avatarSize: number
  valueHandler: (value: string) => void
  sendHandler: () => void
  disabledFlag: boolean
  avatarShow?: boolean;
}

const TestimonialInput = ({ placeholder, avatarSize, valueHandler, sendHandler, disabledFlag, avatarShow = true }: IProps) => {
  const {t} = useTranslation();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [brekPoint, setBrekPoint] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const adjustHeight = useCallback((currentValue: string) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    if (currentValue.length === 0) {
      setBrekPoint(false);
      textarea.style.height = '';
      return;
    }

    textarea.style.height = 'auto';
    const scrollHeight = textarea.scrollHeight;

    const computedStyle = window.getComputedStyle(textarea);
    const lineHeight = parseInt(computedStyle.lineHeight, 10) || 30;
    const paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
    const paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;

    const contentHeight = scrollHeight - paddingTop - paddingBottom;
    const lines = contentHeight / lineHeight;

    if (lines > 2.05) {
      setBrekPoint(true);
      const maxHeight = lineHeight * 4 + paddingTop + paddingBottom; // скільки максимум дозволяємо рости
      textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    } else {
      setBrekPoint(false);
      textarea.style.height = '';
    }
  }, []);

  useLayoutEffect(() => {
    adjustHeight(value);
  }, [value, adjustHeight]);

  return (
    <div className={`${styles.wrapper} ${brekPoint ? styles.wrapperBrekpoint : ''}`}>
      {avatarShow && (
        <div className={styles.avatarWrapper}>
          <img src={testAvatar} alt="avatar" width={avatarSize} height={avatarSize} />
        </div>
      )}

      <div className={`
          ${styles.inputWrapper}
          ${isFocused ? styles.focused : ''}
          ${brekPoint ? styles.breckpoint : ''}
        `}>
        <textarea
          ref={textareaRef}
          className={styles.input}
          placeholder={placeholder}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onInput={(e: any) => adjustHeight(e.target.value)}
          onChange={(e) => {
            setValue(e.target.value)
            valueHandler(e.target.value)
          }}
          value={value}
        />
        <Button
          disabled={disabledFlag}
          title={t('sendComment')}
          submit={() => {
            sendHandler();
            setValue('');
          }}
          className={styles.btn}
        />
      </div>
    </div>
  )
}

export default TestimonialInput;
